import { render, staticRenderFns } from "./Problemlose.vue?vue&type=template&id=277b2e5e&scoped=true&"
import script from "./Problemlose.vue?vue&type=script&lang=ts&"
export * from "./Problemlose.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277b2e5e",
  null
  
)

export default component.exports